import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import LoginService from "./../../../services/auth-service";
import { toast } from "react-toastify";
import React, { useState, useEffect } from "react";

import IconButton from "@mui/material/IconButton";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import RefreshIcon from '@mui/icons-material/Refresh';
import Tooltip from "@mui/material/Tooltip";
import PersonAdd from "@mui/icons-material/PersonAdd";
import Settings from "@mui/icons-material/Settings";
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import Logout from "@mui/icons-material/Logout";
import AccountBoxOutlinedIcon from '@mui/icons-material/AccountBoxOutlined';
import LoaderOverlay from "./../../common/helper/loader.component.js";
import UserService from "./../../../services/user-service";

export default function BasicMenu({ children }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const navigate = useNavigate();
  const [totalBalance, setTotalBalance] = useState(0);
  const [loading, setLoading] = useState(false);

  const userData = useSelector((state) => state.authReducer);
  const totalBalanceData = (stateID) => {
    setLoading(true);
    UserService.getTotalBalance()
      .then((response) => {
        console.log(response.data.data);
        if (response.data.data) {
          setTotalBalance(response.data.data.totalBalance);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const logout = () => {
    LoginService.deleteAccessToken();
    toast.success("Logged out successfully.");
    navigate(process.env.REACT_APP_LOGOUT_URL);
  };
  const profile = () => {
    console.log(userData)
    navigate('/update-profile');
  };
  const viewProfile = () => {
   let id = userData.user.data.user_id;
    navigate('/view-user/'+id);
  };
  useEffect(() => {
    totalBalanceData();
  }, []);
  return (
    <>
    <LoaderOverlay loading={loading} />

    <React.Fragment>
      <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
        <Tooltip title="Account settings">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{  }}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            {children}
            {/* <Avatar sx={{ width: 32, height: 32 }}>M</Avatar> */}
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              width: "230px",
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              paddingTop: 0,
              paddingBottom: 0,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
                paddingTop: 0,
                paddingBottom: 0,
              },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem onClick={handleClose}>
          <div className="d-flex py-2 ">
            <div className="d-flex align-items-center align-self-center">
              <Avatar sx={{color:" #495A69"}}/>
            </div>
            <div>
              <p className="m-0" style={{fontSize:"14px"}}>{userData?.user?.data?.full_name}</p>
              <p className="m-0" style={{fontSize:"14px"}}>{userData?.user?.data?.email_address}</p>
            </div>
          </div>
        </MenuItem>
        {/* <div
          sx={{
            borderBottom: "1px solid #514f4fab",
          }}
        ></div> */}
        <MenuItem
          sx={{   
            paddingBottom: "9px !important",
            paddingTop: "9px !important",
            borderBottom: "1px solid #a7a1a1ab",
            borderTop: "1px solid #a7a1a1ab",
            fontSize:"14px",
            "&:hover": {
              backgroundColor: " #a3d1d5d9", // Change background color on hover
              color: "#495A69", // Change text color on hover
            },
          }}
          onClick={viewProfile}
        >
          <ListItemIcon>
            <AccountBoxOutlinedIcon sx={{color:" #495A69"}} fontSize="medium" />
          </ListItemIcon>
          Profile
        </MenuItem>
        <MenuItem
          sx={{
            borderBottom: "1px solid #a7a1a1ab",
fontSize:"14px",
            paddingBottom: "9px !important",
            paddingTop: "9px !important",
            "&:hover": {
              backgroundColor: " #a3d1d5d9", // Change background color on hover
              color: "#495A69", // Change text color on hover
            },
          }}
         
        >
          <ListItemIcon>
            <MonetizationOnOutlinedIcon sx={{color:" #495A69"}} fontSize="small" />
          </ListItemIcon>
          ₹{totalBalance.toLocaleString()} <RefreshIcon sx={{color:" #495A69",fontSize:"16px"}} fontSize="small" onClick={totalBalanceData}></RefreshIcon>
        </MenuItem>
        <MenuItem
          sx={{
            paddingBottom: "9px !important",
            paddingTop: "9px !important",
            borderBottom: "1px solid #a7a1a1ab",
            fontSize:"14px",
            "&:hover": {
              backgroundColor: " #a3d1d5d9", // Change background color on hover
              color: "#495A69", // Change text color on hover
            },
          }}
          onClick={handleClose}
        >
          <ListItemIcon>
            <Settings sx={{color:" #495A69"}} fontSize="small" />
          </ListItemIcon>
          Settings
        </MenuItem>
        <MenuItem
          sx={{
            paddingBottom: "9px !important",
            paddingTop: "9px !important",
            borderBottom: "1px solid #a7a1a1ab",
            fontSize:"14px",
            "&:hover": {
              backgroundColor: " #a3d1d5d9", // Change background color on hover
              color: "#495A69", // Change text color on hover
            },
          }}
          onClick={profile}
        >
          <ListItemIcon>
            <PersonAdd sx={{color:" #495A69"}} fontSize="small" />
          </ListItemIcon>
          Update Profile
        </MenuItem>
        <MenuItem
          sx={{
            PaddingBottom: "10px",
            paddingTop: "6px",
            fontSize:"14px",
            "&:hover": {
              backgroundColor: " #a3d1d5d9", // Change background color on hover
              color: "#495A69", // Change text color on hover
            },
            // borderBottom: "1px solid black",
          }}
          onClick={logout}
        >
          <ListItemIcon >
            <Logout sx={{color:" #495A69"}} fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </React.Fragment>
    </>
  );
}
